export const SessionDataQueryRaw = /* GraphQL */ `
	query SessionDataQuery @SLA {
		tenant {
			shard
			cloudId
			environment
			activationId
		}
		organization {
			orgId
		}
		user {
			id
			displayName
			timeZone
		}
		getAIConfig(product: CONFLUENCE) {
			isEnabled
			isRovoEnabled
		}
		tenantContext {
			editions {
				confluence
			}
		}
		currentConfluenceUser {
			key
		}
		userAccessStatus
		userLocale
	}
`;
